import { useState } from "react";
import { useHistory, Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import theaters from "../data/theaters.json";
import { ActionTypes } from "../store/types";
import WithMotion from "../utils/withMotion";

import { Slider } from "../components/Slider";

import scss from "./SignUpTheater.module.scss";

export const SignUpTheater = () => {
  const states = Object.keys(theaters);
  const { user, squadSubmission } = useSelector((state: any) => state);
  const [selectedState, setSelectedState] = useState("");
  const [selectedTheater, setSelectedTheater] = useState("");
  const [error, setError] = useState("");
  const history = useHistory();
  const dispatch = useDispatch();

  if (squadSubmission) {
    return <Redirect to="/your-squad" />;
  }
  if (!user) {
    return <Redirect to="/sign-up" />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedTheater) {
      setError("Please select a theater.");
      return;
    }
    dispatch({
      type: ActionTypes.SET_THEATER,
      payload: selectedTheater,
    });
    history.push("/select-squad");
  };

  return (
    <main className={scss.main}>
      <h2 className={scss.instruction}>
        SELECT YOUR THEATER
        <br />
        TO COMPETE AGAINST
        <br />
        YOUR PEERS
      </h2>
      <Slider step={1} />

      <p className={scss.tip}>
        <span style={{ lineHeight: 3 }}>FOR THE BEST EXPERIENCE</span>
        <br />
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.imax.com/movies/the-suicide-squad"
        >
          Buy a ticket
        </a>{" "}
        to an IMAX screening and compete
        <br />
        against your fellow moviegoers. But don't worry, no
        <br />
        ticket or purchase is needed to get your sweepstakes
        <br />
        entry. Just complete the below, pick your squad on
        <br />
        the next screen and you’ll be all set.
      </p>
      <form className={scss.inputContainer} onSubmit={handleSubmit}>
        <label>
          State:
          <select onChange={(e) => setSelectedState(e.target.value)}>
            <option key="default-state" value={""}>
              Choose your State
            </option>
            {states.map((state) => (
              <option key={state} value={state}>
                {state}
              </option>
            ))}
          </select>
        </label>
        <label>
          IMAX Theater
          <select
            onChange={(e) => {
              const index = e.target.value;
              const theater = theaters[selectedState][index];
              setSelectedTheater(theater);
            }}
          >
            <option key="default-theater" value={""}>
              Choose your IMAX Theater
            </option>
            {theaters[selectedState]?.map((theater, index) => (
              <option key={theater.theater_name} value={index}>
                {theater.theater_name}
              </option>
            ))}
          </select>
        </label>

        <button onClick={handleSubmit} className="roundedButton">
          NEXT
        </button>
        <p className={scss.error}>{error}</p>
      </form>
    </main>
  );
};

export default WithMotion(SignUpTheater);
